import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useUserInfor } from "../../../../Context/User";

import {
    AtualizarAsssinaturaUsuarioController,
    CadastrarFotoUsuarioController,
    RegisterController,
} from "../../../../Controllers/Users/UsersController";
import { RegisterUserInterface } from "../../../../Interfaces/Users/UsersInterface";
import { ListarUsuariosController } from "../../../../Controllers/Geral/GestaoUsuarios/UsuariosController";
import LazySelect from "../../../../Components/CardsPages/Forms/LazySelect";
import { ListarModulosController } from "../../../../Controllers/Geral/Documentos/DocumentosController";
import "./styles.css";

export interface ModalCadastrarPropsInterface {
    updateList: () => void;
    setShow: (show: boolean) => void;
}

export default function CadastrarUsuario(props: ModalCadastrarPropsInterface) {
    const { OrgInfor } = useUserInfor();

    const [nrTelefone, setNrTelefone] = useState<string>();

    const [idUsuarioCopia, setIdUsuarioCopia] = useState<number>();
    const [file, setFile] = useState<File>();
    const [fileFotoUsuario, setFileFotoUsuario] = useState<File>();

    const { register, handleSubmit, formState, reset } = useForm();

    const onSubmit = (formData: RegisterUserInterface) => {
        RegisterController(formData, idUsuarioCopia ?? 0)
            .then((res) => {
                if (file) {
                    const formData = new FormData();
                    formData.append("arquivo", file);
                    AtualizarAsssinaturaUsuarioController(formData, res.id);
                }
                if (fileFotoUsuario) {
                    const formData = new FormData();
                    formData.append("arquivo", fileFotoUsuario);
                    CadastrarFotoUsuarioController(formData, res.id);
                }
            })
            .then((res) => {
                props.setShow(false);
                reset();
                props.updateList();
            });
    };

    return (
        <>
            <div className="text-center mb-10 mb-lg-20">
                <h2 className="font-weight-bold">Cadastro de Usuário</h2>
                <p className="text-muted font-weight-bold">
                    Entre com os dados e permissões do usuário
                </p>
            </div>
            <form
                className="form row"
                id="kt_login_signin_form"
                onSubmit={handleSubmit(onSubmit)}
            >
                <div className="form-group col-12 col-lg-6 border-bottom py-3 mb-5">
                    <input
                        className={`form-control h-auto border-0 px-0 placeholder-dark-75 ${
                            formState.errors.DS_GRUPO && "is-invalid"
                        }`}
                        type="text"
                        placeholder="Nome"
                        name="DS_NOME"
                        ref={register({
                            required: "Insira o nome do usuário",
                        })}
                        autoComplete="off"
                    />
                    <div className="invalid-feedback">
                        {formState.errors.DS_NOME
                            ? formState.errors.DS_NOME.message
                            : ""}
                    </div>
                </div>
                <div className="form-group col-12 col-lg-6 border-bottom py-3 mb-5">
                    <input
                        className={`form-control h-auto border-0 px-0 placeholder-dark-75 ${
                            formState.errors.DS_EMAIL && "is-invalid"
                        }`}
                        type="email"
                        placeholder="Email"
                        name="DS_EMAIL"
                        ref={register({
                            required: "Insira o email do usuário",
                        })}
                        autoComplete="off"
                    />
                    <div className="invalid-feedback">
                        {formState.errors.DS_EMAIL
                            ? formState.errors.DS_EMAIL.message
                            : ""}
                    </div>
                </div>
                {!OrgInfor?.FL_SSO && (
                    <>
                        <div className="form-group col-12 col-lg-6 border-bottom py-3 mb-5">
                            <label></label>
                            <input
                                className={`form-control h-auto border-0 px-0 placeholder-dark-75 ${
                                    formState.errors.DS_LOGIN && "is-invalid"
                                }`}
                                type="text"
                                placeholder="Login"
                                name="DS_LOGIN"
                                ref={register({
                                    required: "Insira o login do usuário",
                                })}
                                autoComplete="off"
                            />
                            <div className="invalid-feedback">
                                {formState.errors.DS_LOGIN
                                    ? formState.errors.DS_LOGIN.message
                                    : ""}
                            </div>
                        </div>
                        <div className="form-group col-12 col-lg-6 border-bottom py-3 mb-5">
                            <label></label>
                            <input
                                className={`form-control border-0 placeholder-dark-75 ${
                                    formState.errors.DS_SENHA && "is-invalid"
                                }`}
                                type="password"
                                placeholder="Senha"
                                name="DS_SENHA"
                                ref={register({
                                    required: "Insira a senha do usuário",
                                })}
                                autoComplete="new-password"
                            />
                            <div className="invalid-feedback">
                                {formState.errors.DS_SENHA
                                    ? formState.errors.DS_SENHA.message
                                    : ""}
                            </div>
                        </div>
                    </>
                )}

                <div className="form-group col-12 col-lg-6 py-3 mb-5">
                    <label>DDI</label>
                    <input
                        className={`form-control h-auto px-0 placeholder-dark-75 ${
                            formState.errors.COD_DDI && "is-invalid"
                        }`}
                        id="COD_DDI"
                        name="COD_DDI"
                        ref={register({
                            required:
                                nrTelefone && nrTelefone.length > 0
                                    ? "Insira o DDI"
                                    : false,
                        })}
                    />

                    <div className="invalid-feedback">
                        {formState.errors.COD_DDI
                            ? formState.errors.COD_DDI.message
                            : ""}
                    </div>
                </div>

                <div className="form-group col-12 col-lg-6 py-3 mb-5">
                    <label>DDD</label>
                    <input
                        className={`form-control h-auto px-0 placeholder-dark-75 ${
                            formState.errors.COD_DDD && "is-invalid"
                        }`}
                        id="COD_DDD"
                        name="COD_DDD"
                        ref={register({
                            required:
                                nrTelefone && nrTelefone.length > 0
                                    ? "Insira o DDD"
                                    : false,
                        })}
                    />
                    <div className="invalid-feedback">
                        {formState.errors.COD_DDD
                            ? formState.errors.COD_DDD.message
                            : ""}
                    </div>
                </div>

                <div className="form-group col-12 col-lg-6 py-3 mb-5">
                    <label>Telefone</label>
                    <input
                        className={`form-control h-auto px-0 placeholder-dark-75 ${
                            formState.errors.NR_TELEFONE_WPP && "is-invalid"
                        }`}
                        id="NR_TELEFONE_WPP"
                        name="NR_TELEFONE_WPP"
                        onChange={(e) => {
                            setNrTelefone(e.target.value);
                        }}
                        maxLength={9}
                        ref={register()}
                    />

                    <div className="invalid-feedback">
                        {formState.errors.NR_TELEFONE_WPP
                            ? formState.errors.NR_TELEFONE_WPP.message
                            : ""}
                    </div>
                </div>

                <div className="form-group col-12 col-lg-6 py-3 mb-5">
                    <LazySelect
                        className="form-control placeholder-dark-75"
                        label="Copiar perfil de"
                        name="ID_USUARIO"
                        controller={ListarUsuariosController}
                        getKeyValue={(u) => u.ID_USUARIO}
                        getDS={(u) => u.DS_NOME}
                        onChange={(e) =>
                            setIdUsuarioCopia(Number(e.target.value))
                        }
                    >
                        <option></option>
                    </LazySelect>
                </div>

                <div className="form-group col-12 col-lg-6 border-bottom py-3 mb-5">
                    <div className="custom-file">
                        <input
                            type="file"
                            className="custom-file-input border-bottom"
                            id="arquivo"
                            onChange={(e) => {
                                if (e.target.files) {
                                    setFileFotoUsuario(e.target.files?.[0]);
                                }
                            }}
                        />
                        <label className="custom-file-label" htmlFor="arquivo">
                            {fileFotoUsuario?.name ?? "Foto do Usuário"}
                        </label>
                        <div className="invalid-feedback">
                            {formState.errors.arquivo
                                ? formState.errors.arquivo.message
                                : ""}
                        </div>
                    </div>
                </div>

                <div className="form-group col-12 col-lg-6 border-bottom py-3 mb-5">
                    <div className="custom-file">
                        <input
                            type="file"
                            className="custom-file-input border-bottom"
                            id="assinaturaUsuario"
                            onChange={(e) => {
                                if (e.target.files) {
                                    setFile(e.target.files?.[0]);
                                }
                            }}
                        />
                        <label
                            className="custom-file-label"
                            htmlFor="assinaturaUsuario"
                        >
                            {file?.name ?? "Assinatura do Usuário"}
                        </label>
                        <div className="invalid-feedback">
                            {formState.errors.assinaturaUsuario
                                ? formState.errors.assinaturaUsuario.message
                                : ""}
                        </div>
                    </div>
                </div>

                <div className="form-group col-12 col-lg-6 py-3 mb-5">
                    <LazySelect
                        className="form-control placeholder-dark-75"
                        label="Módulo Principal"
                        name="ID_MODULO"
                        controller={ListarModulosController}
                        getKeyValue={(u) => u.ID_MODULO}
                        getDS={(u) => u.DS_MODULO}
                    >
                        <option></option>
                    </LazySelect>
                </div>

                <div className="form-group col-12 mb-5">
                    <div className="col-12 d-flex flex-column align-itens-center justify-content-center">
                        <div className="text-center font-weight-bold">
                            Administrador:
                        </div>
                        <span
                            className="switch switch-outline switch-sm switch-icon switch-info d-flex justify-content-center"
                            data-toggle="tooltip"
                        >
                            <label>
                                <input
                                    id="fL_ADMINISTRADOR_STATUS"
                                    name="fL_ADMINISTRADOR"
                                    defaultChecked={false}
                                    ref={register()}
                                    type="checkbox"
                                />
                                <span></span>
                            </label>
                        </span>
                    </div>
                </div>
                <div className="d-flex flex-wrap justify-content-center align-items-center col-12">
                    <button
                        type="submit"
                        id="kt_login_signin_submit"
                        className="btn btn-capys font-weight-bold px-9 py-4 my-2"
                    >
                        Cadastrar
                    </button>
                </div>
            </form>
        </>
    );
}
